module.exports = function() {
  return new Worker(__webpack_public_path__ + "94f578c3ccd69b6dc283.worker.js");
};